<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Usuario">
          <b-form>
            <b-form-group
              label="Nombre de Usuario"
              label-for="username"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="username"
                v-model.trim="$v.username.$model" 
                :state="usernameValido"
                type="text"
                :readonly="(id == 0) ? false : true"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="usernameFeedback">
                {{ usernameInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Rol"
              label-for="usuarioRol"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="usuarioRolNombre" 
                :options="usuariosRolesList" 
                :state="usuarioRolValido"
                class="mb-3"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null" disabled>Seleccione un rol</option>
                </template>
              </b-form-select>                 
              <b-form-invalid-feedback id="usuarioRolFeedback">
                {{ usuarioRolInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>  

            <b-form-group
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="apellido"
                v-model.trim="$v.apellido.$model" 
                :state="apellidoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Password"
              label-for="emailPassword"
              :label-cols="labelCols"
              description="Email Password (Google App Password)"
              horizontal>
              <b-form-input 
                id="emailPassword"
                v-model.trim="$v.emailPassword.$model" 
                :state="emailPasswordValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailPasswordFeedback">
                {{ emailPasswordInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  :value="true"
                  :unchecked-value="false">
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuario/getField',
  mutationType: 'usuario/updateField',
});

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      usernameValido: null,
      usernameInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      emailPasswordValido: null,
      emailPasswordInvalidoMsj: '',
      usuarioRolValido: null,
      usuarioRolInvalidoMsj: '',

      usuariosRoles: [],
      usuariosRolesList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'username',
      'usuarioRol',
      'usuarioRolNombre',
      'apellido',
      'nombre',
      'email',
      'emailPassword',
      'inactivo',
    ])
  },  
  created() {
    var usuarioId = 0;

    if (this.$route.params){
      if (this.$route.params.id){
        usuarioId = this.$route.params.id;
      }
    }
    this.getDatosAdicionales();
    
    this.showSpinner();
    this.$store.dispatch('usuario/inicializar', usuarioId)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;
      
      this.$store.dispatch('usuariosroles/getUsuariosRolesList')
        .then(() => {
            vm.usuariosRoles = this.$store.getters['usuariosroles/usuariosRolesList'];
            vm.usuariosRolesList = this.$store.getters['usuariosroles/usuariosRolesSelectList'];
          })
        .catch(() => this.showErrorMsj ('Se produjo un error al recuperar la información de roles'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "username" || validarTodos) {
        if (this.$v.username.$error) {
          this.usernameValido = false;
          if (!this.$v.username.required) {
            this.usernameInvalidoMsj = 'Debe ingresar el nombre de usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.usernameInvalidoMsj = 'El nombre de usuario sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.usernameValido = null;
          this.usernameInvalidoMsj = '';
        }
      }

      if (campo == 'usuarioRolNombre' || validarTodos) {
        this.usuarioRolValido = false;
        if (this.usuarioRolNombre == null) {
          this.usuarioRolInvalidoMsj = 'Debe seleccionar el rol del usuario';
        } else {
          this.usuarioRolValido = null;
          this.usuarioRolInvalidoMsj = '';
        }
      }

      if (campo == "apellido" || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido del usuario';
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido del usuario sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre del usuario sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == "email" || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.required) {
            this.emailInvalidoMsj = 'Debe ingresar el email del usuario';
          } else if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser válido.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == "emailPassword" || validarTodos) {
        if (this.$v.emailPassword.$error) {
          this.emailPasswordValido = false;
          if (!this.$v.emailPassword.maxLength) {
            this.emailPasswordInvalidoMsj = 'El password sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.emailPasswordValido = null;
          this.emailPasswordInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      var usuarioRol = null;
      if (this.usuarioRolNombre) {
        usuarioRol = this.getSelected(this.usuariosRoles, this.usuarioRolNombre);
      }
      this.$store.dispatch('usuario/setUsuarioRol', usuarioRol);

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('usuario/save')
          .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
    // goBack() {
    //   this.$router.push({ name: 'Usuarios' });
    // },
    goList() {
      this.$router.push({ name: 'Usuarios' });
    }
  },
  watch: {
    'usuarioRolNombre': function(newVal, oldVal) {
      if ( newVal != oldVal) {
        if (newVal) {
          this.usuarioRolValido = null;
          this.usuarioRolInvalidoMsj = '';
        }
      }
    },
  },
  validations: {
    username: {
      required,
      maxLength: maxLength(50)
    },
    apellido: {
      required,
      maxLength: maxLength(150)
    },
    nombre: {
      required,
      maxLength: maxLength(150)
    },
    email: {
      required,
      email,
      maxLength: maxLength(150)
    },
    emailPassword: {
      maxLength: maxLength(150)
    },
  },  
}
</script>

<style>
</style>
